import styles from "./BreakTypeFormFields.module.scss";
import { nameof } from "ts-simple-nameof";
import { IBreakTypeInputModel } from "../models/breakTypeInputModel";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { AppColorPicker } from "../../../../common/components/forms/inputs/colorPicker/AppColorPicker";
import { TextEditor } from "../../../../common/components/forms/inputs/textEditor/TextEditor";

export const BreakTypeFormFields = () => {
  return (
    <div className={styles.root}>
      <DefaultInputField
        name={nameof<IBreakTypeInputModel>((x) => x.name)}
        label="Име на типа блокиране"
        placeholder="Обяд"
        required
      />

      <DefaultInputField
        name={nameof<IBreakTypeInputModel>((x) => x.durationInMinutes)}
        label="Продължителност (минути)"
        placeholder="30"
        type="number"
        min={5}
        max={480}
        required
      />

      <AppColorPicker
        name={nameof<IBreakTypeInputModel>((x) => x.color)}
        label="Цвят в календара"
      />

      <TextEditor
        name={nameof<IBreakTypeInputModel>((x) => x.description)}
        label="Описание"
        placeholder="Обедна почивка за персонала"
      />
    </div>
  );
};
